import type { ThemeWithoutTokens } from '../theme.types';

export const bannerTokens = (theme: ThemeWithoutTokens) =>
  ({
    bannerCloseIconColor: theme.palette.grey500,
    bannerCloseIconFontSize: theme.typography.fontSize.s,
    bannerCloseIconPaddingX: theme.space.component.x.m,
    bannerCloseIconPaddingY: theme.space.component.y.m,
  }) as const;
